import { deserialize, fetchWrapper } from '../fetch';
import type { InboxNotification, Notification } from './interface';

export const NOTIFICATIONS_PAGE_SIZE = 5;

export const fetchNotifications = async (): Promise<{
  notifications: Notification[];
  count: number;
}> => {
  const url = new URL('/app/v1/notifications', API_BASE_URL);

  url.searchParams.set('limit', `${NOTIFICATIONS_PAGE_SIZE}`);

  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const setStatus = async (data: {
  notification_id: string;
  is_read?: boolean;
  is_dismissed?: boolean;
}): Promise<void> => {
  const url = new URL(
    `/app/v1/notifications/${data.notification_id}/status`,
    API_BASE_URL
  );
  return deserialize(
    await fetchWrapper(url.href, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify({
        is_read: data.is_read,
        is_dismissed: data.is_dismissed,
      }),
    })
  );
};

export const fetchInbox = async (data: {
  limit: number;
  offset?: number;
}): Promise<{
  notifications: InboxNotification[];
  count: number;
}> => {
  const url = new URL('/app/v1/notifications/dossiers', API_BASE_URL);

  url.searchParams.set('limit', `${data.limit}`);
  if (data.offset) {
    url.searchParams.set('offset', `${data.offset}`);
  }

  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const fetchRecentInbox = async (): Promise<{
  notifications: InboxNotification[];
}> => {
  const url = new URL('/app/v1/notifications/dossiers', API_BASE_URL);

  url.searchParams.set('limit', '3');
  url.searchParams.set('max_notifications', '0');
  url.searchParams.set('unread', 'true');

  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const setDossierAsRead = async (data: {
  dossierId: string;
}): Promise<void> => {
  const url = new URL(
    `/app/v1/notifications/dossiers/${data.dossierId}/read`,
    API_BASE_URL
  );

  return deserialize(
    await fetchWrapper(url.href, { method: 'PUT', credentials: 'include' })
  );
};
